import RegisterGame from './register';

export default RegisterGame;
